var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M895,993.8c-27.3,0-49.4-22.1-49.4-49.4v-98.8c0-81.7-66.4-148.1-148.1-148.1h-395c-81.7,0-148.1,66.4-148.1,148.1v98.8 c0,27.3-22.1,49.4-49.4,49.4s-49.4-22.1-49.4-49.4v-98.8c0-136.1,110.8-246.9,246.9-246.9h395c136.1,0,246.9,110.8,246.9,246.9 v98.8C944.4,971.7,922.3,993.8,895,993.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,500c-136.1,0-246.9-110.8-246.9-246.9S363.9,6.2,500,6.2S746.9,117,746.9,253.1S636.1,500,500,500z M500,105 c-81.7,0-148.1,66.4-148.1,148.1S418.3,401.2,500,401.2s148.1-66.4,148.1-148.1S581.7,105,500,105z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlack);
export default __webpack_public_path__ + "static/media/person-black.b468cf487e24cc9c8a55b260afe21fe1.svg";
export { ForwardRef as ReactComponent };